import OapFloatingIsland from './code/Scripts/components/OapFloatingIsland.vue';

export default {
  components: {
    OapFloatingIsland,
  },
};
